<template>
    <div class="loginBG">
        <div class="titleBox">{{model1 == 1?'百捷':model1 == 2?'青檬':''}}英语出题器投屏教学</div>



        <div class="checkTba" v-if="isQr && model1" @click="checkTab">切换到账号密码登陆</div>
        <div class="checkTba" v-if="!isQr && model1" @click="checkTab">切换到扫码登陆</div>
        <div class="loginQr" v-if="isQr && model1">
          <div class="boxCheckOut" v-if="isShowOut" @click="boxCheckOut">
            <img src="../assets/resetIcon1.png" alt="">
            <div>二维码已过期</div>
          </div>
          <img v-if="src" :src="src" alt="" srcset="">
          <div class="loginInfo">微信扫码登录</div>
        </div>
        <div class="infos" v-if="isQr && model1">提示，如扫码登录没反应，建议使用360浏览器，或使用账号登录。</div>
        <div class="loginQr" v-if="!isQr" style="width:410px;height:180px">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
            <Row >
             <Form-item prop="user">
                <Input type="text" size="large" v-model="formInline.user" placeholder="请填写手机号">
                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                </Input>
            </Form-item>
            </Row>
           <Row >
               <Form-item prop="password">
                  <Input type="password" size="large" v-model="formInline.password" placeholder="请填写密码">
                      <Icon type="ios-unlock-outline" slot="prepend"></Icon>
                  </Input>
              </Form-item>
           </Row>
            <Checkbox v-model="setPassword">记住账号密码</Checkbox>
            <Row >
              <Form-item style="text-align: center;">
                  <Button style="width:200px;" type="primary" @click="handleSubmit('formInline')">登录</Button>
              </Form-item>
             </Row>
           
        </Form>
        <div class="infos">提示：进入小程序首页底部“我的”——“设置关联账号”即可使用账号登录</div>
        </div>
        <div class="downBtns"  v-if="fromUrl!='app'">
          <div class="topInfos">提示：Ctrl+D 可快速收藏本网页！</div>
          <div class="topInfos">下次在收藏夹可直接打开，更便捷！</div>
        </div>
        <div class="downBtns1" v-if="fromUrl!='app'">
          <div class="topInfos">使用桌面登录器，无需每次输入网址</div>
          <div class="topInfos">请下载保存到桌面上<Button type="primary" @click="frontDownload" class="goback">点击下载</Button></div>
        </div>
        <div class="bottomsBoxBn">南通百捷网络科技有限公司<a target="_blank" style="margin-left:40px;color:#fff;text-decoration:underline" href="https://beian.miit.gov.cn/">苏ICP备17059974号-1</a></div>
    </div>

</template>
  
  <script>
import axios from "axios";
import qs from "qs"
import ASEUrl from "../cryptojs/secret"
export default {
    data() {
      return {
        src:'',
        fromUrl:'',
        RandomCode:'',
        isQr:true,
        formInline: {
            user: '',
            password: ''
        },
        ruleInline: {
            user: [
                { required: true, message: '请填写用户绑定手机号', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '请填写密码', trigger: 'blur' },
                // { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
            ]
        },
         setPassword:false,
        model1:'',
        setFunc:null,
        isShowOut:false
      };
    },
    created() {
      this.fromUrl =this.$route.query.from
      // 根据 qtype 确定小程序：qmyy=青檬英语，emi（默认）=百捷英语
      this.model1 = this.$route.query.qtype == 'qmyy' ? '2' : '1'
      this.queryQr()
       if(window.localStorage.getItem('userNameEn')){
        this.formInline.user = window.localStorage.getItem('userNameEn')
      }
      if(window.localStorage.getItem('passwordEn')){
        this.formInline.password = window.localStorage.getItem('passwordEn')
      }
    },
    mounted() {
     
    },
    
    methods: {
      frontDownload() {
      var a = document.createElement("a"); //创建一个<a></a>标签
      
      a.href ="https://r.bjwxjs.com/exe%E7%A8%8B%E5%BA%8F/%E7%99%BE%E6%8D%B7%E8%8B%B1%E8%AF%AD%E6%8A%95%E5%B1%8F.exe"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "百捷英语投屏.exe"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
  },
       handleSubmit(name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
              const that = this
               let url = this.model1 == 1?'v1/login':'qmyy/v1/login'
              axios({
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: 'POST',
                url: url,
                data: qs.stringify({
                  phone :this.formInline.user,
                  password: this.formInline.password,
                })
              })
              .then((res) => {
                if (typeof res.data === 'string') {
                  res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
                } 
                if(res.data.code == 0){
                   window.localStorage.setItem('sessionId',res.data.data.sessionId)
                  //  that.$router.push({path:'/topicList',query:{}});
                   if(this.setPassword){
                      window.localStorage.setItem('userNameEn',this.formInline.user)
                      window.localStorage.setItem('passwordEn', this.formInline.password)
                   }
                    const qtype = this.$route.query.qtype
                    if (window.ActiveXObject || "ActiveXObject" in window){
                      window.location.href = qtype ? '/topicList?qtype='+qtype : '/topicList'
                    }else{
                      that.$router.push({path:'/topicList',query: qtype ? {qtype: qtype} : {}});
                    }

                }else{
                  that.$Message.error(res.data.msg);
                }
              })
              .catch((err) => {
              });
            } else {
                this.$Message.error('表单验证失败!');
            }
        })
    },
      checkTab(){
        this.isQr = !this.isQr
      },
      boxCheckOut(){
        clearTimeout(this.items)
        this.isShowOut = false
        this.queryQr()
      },
      queryQr(){
        const that = this
         const t = Date.now()
          let url = this.model1 == 1?'v1/wx/qrcode':'qmyy/v1/wx/qrcode'
        axios({
           headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          method: 'GET',
          url: url,
        })
        .then((res) => {
         
          if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
          if(res.data.success){
            that.src = res.data.data.QRCodeStr
            that.RandomCode = res.data.data.RandomCode,
            that.queryLoginSatus()
          }else{
            that.$Message.error('获取二维码错误');
          }
          

        })
        .catch((err) => {
        });
      },
      queryLoginSatus(){
        let t = Date.now()
        const that = this
        let url = this.model1 == 1?'v1/web/CheckLogin?code='+that.RandomCode:'qmyy/v1/web/CheckLogin?code='+that.RandomCode
        axios({
           headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          method: 'GET',
          url: url+'&t='+t,
          
        })
        .then((res) => {
          if (typeof res.data === 'string') {
            res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
          } 
          if(res.data.success){
            window.localStorage.setItem('sessionId',res.data.data.sessionId)
            // https://testyingyu.bjwxjs.com/topicList
            const qtype = this.$route.query.qtype
            if (window.ActiveXObject || "ActiveXObject" in window){
              window.location.href = qtype ? '/topicList?qtype='+qtype : '/topicList'
            }else{
              that.$router.push({path:'/topicList',query: qtype ? {qtype: qtype} : {}});
            }
          }else{
            if(res.data.msg == '二维码过期'){
               this.isShowOut = true
            }else{
              this.setFunc = setTimeout(() => {
              that.queryLoginSatus()
            }, 1000);
            }
           
          }

        })
        .catch((err) => {
        });
      },
    },
  };
  </script>
  
  <style scoped>
    .loginBG{
        width: 100%;
        height: 100%;
        background: url('https://r.bjwxjs.com/PC_kpy/login_bg%402x.png') 0 0 / 100% 100% no-repeat;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .titleBox{
        font-size: 50px;
        font-family: HiraginoSansGB-W6, HiraginoSansGB;
        font-weight: normal;
        color: #FFFFFF;
        letter-spacing: 5px;
        text-shadow: 0px 0px 209px rgba(29,92,171,0.74);
        text-align: center;
        margin-top: 100px;

    }
    .loginQr{
      width: 340px;
      height: 380px;
      background: #FFFFFF;
      border-radius: 10px;
      backdrop-filter: blur(10px);
      margin:20px auto 0;
      padding: 20px;
    }
    .loginQr img{
        width: 100%;
        height: 300px;
        

    }
    .loginInfo{
      font-size: 26px;
      font-family: HiraginoSansGB-W3, HiraginoSansGB;
      font-weight: normal;
      color: #303133;
      letter-spacing: 4px;
      text-align: center;
    }
    
    .checkTba{
      font-size: 24px;
      width: 240px;
      height: 50px;
      border-radius: 25px;
      background-color: #fff;
      line-height: 50px;
      text-align: center;
      margin: 30px auto 0;
      color: #5190F9 ;
      cursor: pointer 
    }
    
   .ivu-form-inline .ivu-form-item{
    width: 100%;
   }
   .bottomsBoxBn{
    position: absolute;
    width: 100%;
    bottom: 20px;
    left: 0;
    text-align: center;
    color: #fff;
   }
  .downBtns{
    position: absolute;
    right: 30px;
    top: 40px;
    color: #fff;
    font-size: 20px;
  }
  .downA{
    text-decoration-line: none;
    width: 120px;
    height: 30px;
    display: inline-block;
    background-color: #FEBC67;
    color: #fff;
    text-align: center;
    border-radius: 3px;
  }
  .goback{
    margin-left: 30px;
    background-color: #FEBC67;
  }
  .infos{
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 40px;
  }
  .downBtns1{
    position: absolute;
    right: 30px;
    top: 150px;
    color: #fff;
    font-size: 20px;
  }
  /deep/ .ivu-select-large.ivu-select-single .ivu-select-selection{
    height: 60px;
    line-height: 60px;
  }
  /deep/ .ivu-select-large.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
     height: 60px;
     line-height: 60px;
     font-size: 20px;
  }
  /deep/ .ivu-select-large .ivu-select-item{
    height: 50px;
    line-height: 40px;
    font-size: 20px !important;
    box-sizing: border-box;
  }
  /deep/ .ivu-select-dropdown{
    max-height: 120px !important;
    overflow: hidden;
  }
  /deep/ .ivu-select-large.ivu-select-single .ivu-select-selection .ivu-select-placeholder{
    height: 60px;
    line-height: 60px;
    font-size: 20px;
}
.boxCheckOut{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  text-align: center;
}
.boxCheckOut img{
  width: 80px;
  height: 80px;
  margin-top: 120px;
}
.boxCheckOut div{
  text-align: center;
  line-height: 40px;
  font-size: 24px;
  margin-top: 30px;
  color: #fff;
  font-weight: 600;
}

  </style>
  